import React, { useState } from 'react';
import { getClinics } from '../../api';

const DatalensPage = () => {
  const [clientId, setClientId] = useState('');
  const [dashboardUrl, setDashboardUrl] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleShowDashboard = async (e) => {
    e.preventDefault();
    if (!clientId) {
      setMessage('Введите Client ID клиники.');
      return;
    }

    setIsLoading(true);
    setDashboardUrl('');
    setMessage('');

    try {
      const allClinics = await getClinics();
      const foundClinic = allClinics.find(c => c.client_id === clientId);

      if (foundClinic) {
        if (foundClinic.datalens_dashboard_url) {
          setDashboardUrl(foundClinic.datalens_dashboard_url);
        } else {
          setMessage('Для этой клиники дашборд еще не настроен.');
        }
      } else {
        setMessage('Клиника с таким Client ID не найдена.');
      }
    } catch (error) {
      setMessage(error.message || 'Ошибка при поиске клиники.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="py-6 px-4">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold mb-4">
          Аналитические дашборды <span className="gradient-text">DataLens</span>
        </h1>
        <p className="text-gray-500 text-xl max-w-2xl mx-auto">
          Введите Client ID клиники для просмотра её аналитического дашборда.
        </p>
      </div>

      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
        <form onSubmit={handleShowDashboard}>
          <div className="grid grid-cols-1 gap-6">
            <div>
              <label htmlFor="client-id-input" className="block text-sm font-medium text-gray-600 mb-2">
                Client ID клиники
              </label>
              <input
                id="client-id-input"
                type="text"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                placeholder="Введите Client ID"
                className="w-full bg-white border border-gray-200 rounded-md p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button 
              type="submit"
              disabled={isLoading}
              className="w-full bg-blue-600 text-white py-2.5 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
            >
              {isLoading ? 'Загрузка...' : 'Показать дашборд'}
            </button>
          </div>
        </form>
      </div>

      {message && (
        <div className="max-w-4xl mx-auto mt-6 p-4 bg-yellow-100 text-gray-800 rounded-md text-center">
          <p>{message}</p>
        </div>
      )}

      {dashboardUrl && (
        <div className="max-w-full mx-auto mt-8">
          <iframe
            title="Datalens Dashboard"
            src={dashboardUrl}
            width="100%"
            height="800px"
            className="border-2 border-gray-200 rounded-lg shadow-lg"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default DatalensPage;

